import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { WebinarMCPage } from './pages/WebinarMCPage';
import { MCBedanktPage } from './pages/MCBedanktPage';
import { QuizPage } from './pages/QuizPage';
import { Adv2bPage } from './pages/Adv2bPage';
import { VerlatingsangstPage } from './pages/VerlatingsangstPage';
import { VerlatingsangstPageG } from './pages/VerlatingsangstPageG';
import { VerlatingsangstWebinarPage } from './pages/VerlatingsangstWebinarPage';
import { LiefdevolCommunicerenCursusPage } from './pages/LiefdevolCommunicerenCursusPage';
import { MetaPixel } from './components/MetaPixel';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <MetaPixel data-id="element-3" />
      <Routes data-id="element-4">
        <Route path="/" element={<Adv2bPage data-id="element-6" />} data-id="element-5" />
        <Route path="/adv2b" element={<Adv2bPage data-id="element-8" />} data-id="element-7" />
        <Route path="/webinar-mc" element={<WebinarMCPage data-id="element-10" />} data-id="element-9" />
        <Route path="/mc-bedankt" element={<MCBedanktPage data-id="element-12" />} data-id="element-11" />
        <Route path="/quiz" element={<QuizPage data-id="element-14" />} data-id="element-13" />
        <Route path="/verlatingsangst-kernaanpak" element={<VerlatingsangstPage data-id="element-16" />} data-id="element-15" />
        <Route path="/verlatingsangst-kernaanpak-g" element={<VerlatingsangstPageG data-id="element-18" />} data-id="element-17" />
        <Route path="/verlatingsangst-webinar" element={<VerlatingsangstWebinarPage data-id="element-20" />} data-id="element-19" />
        <Route path="/liefdevol-communiceren-cursus" element={<LiefdevolCommunicerenCursusPage data-id="element-22" />} data-id="element-21" />
      </Routes>
    </BrowserRouter>;
}